import DataStoreRequest from "../../../components/Admin/DatastoreRequests/DataStoreRequest";
import { useEffect } from "react";
import { fetchBizLayerQuery } from "../../../components/Admin/DatastoreRequests/DataStoreHelpers/dataStoreHelpers";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData, selectUserToken } from "../../../features/userSlice";
import {
  setIsLoading,
  setQueryOutputTableData,
} from "../../../features/dataStoreReqSlice";
import { useSearchParams } from "react-router-dom";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../components/Page404/Page403";

const DataStoreRequestScreen = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectUserToken);
  const [searchParams, setSearchParams] = useSearchParams();
  const response = useSelector(selectUserData);
  const hasDataStoreViewPermission = CheckPermissions(
    response?.data?.products?.admin,
    "datastore_requests",
    "view_datastore_requests"
  );

  useEffect(() => {
    if (hasDataStoreViewPermission) {
      dispatch(setQueryOutputTableData(null));
      fetchBizLayerQuery(token, dispatch, setIsLoading);
    } else {
      dispatch(setIsLoading(false));
    }
    // eslint-disable-next-line
  }, [token, dispatch]);

  useEffect(() => {
    const updatedParams = new URLSearchParams(searchParams.toString());

    if (updatedParams.has("queryId")) {
      updatedParams.delete("queryId");
    }

    if (updatedParams.has("id")) {
      updatedParams.delete("id");
    }

    setSearchParams(updatedParams); // Update the URL search parameters
    // eslint-disable-next-line
  }, [searchParams]);

  return <>{hasDataStoreViewPermission ? <DataStoreRequest /> : <Page404 />}</>;
};

export default DataStoreRequestScreen;
